import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  getGame: false,
  appendMedia: false,
  removeMedia: false,
  updateNews: false,
  updateScoreBoard: false,
};

const Game = {
  getGame: ({ seasonUniqid, gameUniqid }) => {
    return ApiService.get(`/api/seasons/${seasonUniqid}/games/${gameUniqid}`);
  },

  appendMedia: ({ seasonUniqid, gameUniqid, mediaList }) => {
    if (debugStatus.appendMedia) {
      return fakeApiHelper(200, 'success', {
        data: {
          game_uniqid: 'game_uniqid',
          media: [],
          link: 'https://www.rebas.tw/season/season_uniqid?game=game_uniqid',
        },
        error: false,
        message: 'apend media successfully',
      });
    }

    return ApiService.post(`/api/seasons/${seasonUniqid}/games/${gameUniqid}/media`, {
      data: mediaList,
    });
  },

  removeMedia: ({ seasonUniqid, gameUniqid, mediaPaths, mediaType }) => {
    if (debugStatus.removeMedia) {
      return fakeApiHelper(200, 'success', {
        data: {
          game_uniqid: 'game_uniqid',
          media: [],
          link: 'https://www.rebas.tw/season/season_uniqid?game=game_uniqid',
        },
        error: false,
        message: 'remove media successfully',
      });
    }

    let pathQuery = '';
    mediaPaths.forEach((mediaPath, index) => {
      if (index !== 0) {
        pathQuery += '&';
      }
      pathQuery += `path=${encodeURI(mediaPath)}`;
    });

    return ApiService.delete(`/api/seasons/${seasonUniqid}/games/${gameUniqid}/media?${pathQuery}&type=${mediaType}`);
  },

  updateNews: ({ seasonUniqid, gameUniqid, data }) => {
    return ApiService.put(`/api/seasons/${seasonUniqid}/games/${gameUniqid}/news`, {
      data,
    });
  },

  deleteNews: ({ seasonUniqid, gameUniqid }) => {
    return ApiService.delete(`/api/seasons/${seasonUniqid}/games/${gameUniqid}/news`);
  },

  updateRelatedLinks: ({ seasonUniqid, gameUniqid, data }) => {
    return ApiService.put(`/api/seasons/${seasonUniqid}/games/${gameUniqid}/related_links`, {
      data,
    });
  },

  updateScoreBoard: ({ seasonUniqid, gameUniqid, data }) => {
    return ApiService.put(`/api/seasons/${seasonUniqid}/games/${gameUniqid}/scoreboard`, {
      data,
    });
  },

  updateStats: ({ seasonUniqid, gameUniqid, data }) => {
    return ApiService.put(`/api/seasons/${seasonUniqid}/games/${gameUniqid}/stats`, {
      data,
    });
  },

  updatePbP: ({ seasonUniqid, gameUniqid, data }) => {
    return ApiService.put(`/api/seasons/${seasonUniqid}/games/${gameUniqid}/pbp`, {
      data,
    });
  },
};

export default Game;
